import React from 'react'
import { CircleFill } from 'react-bootstrap-icons'
import {
  MaxFilterContainer,
  MaxItem,
  MaxItemContainer,
  ProgressBar,
  ProgressContentWrapper,
  Description
} from '../styles'
import { useConfig, useLanguage, useUtils } from '~components'
import { FilterAccordion } from '../Accordion'
import { capitalize } from '~ui'

export const MaxSectionItem = (props) => {
  const {
    filters,
    handleChangeFilters,
    title,
    options,
    filter,
    onClick,
    defaultOpen = false,
    description
  } = props

  const [, t] = useLanguage()
  const [{ parsePrice }] = useUtils()
  const [{ configs }] = useConfig()

  const distanceUnit = configs?.distance_unit?.value

  const units = {
    mi: 1609,
    km: 1000
  }

  const parseValue = (option) => {
    return filter === 'max_distance'
      ? `${(option / units[distanceUnit]).toFixed(0)} ${t(`${distanceUnit?.toUpperCase()}`, capitalize(distanceUnit))}`
      : filter === 'max_eta'
        ? `${option} ${t('TIME_MIN', 'min')}`
        : filter === 'max_delivery_price'
          ? `$${option}`
          : parsePrice(option)
  }

  const handleBarClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect()
    const position = ((e.clientX - rect.left) / rect.width) * 100
    const stepSize = 100 / (options.length - 1)
    const selectedIndex = Math.round(position / stepSize)
    const selectedOption = options[selectedIndex]
    handleChangeFilters(filter, selectedOption)
  }

  const currentPosition = ((options.indexOf(filters?.[filter]) / (options.length - 1)) * 100) ?? 0

  return (
    <MaxFilterContainer>
      <FilterAccordion title={title} onClick={onClick} defaultOpen={defaultOpen}>
        {description && <Description>{description}</Description>}
        {filter === 'max_delivery_price' && !!filters?.[filter] && (
          <p className='under-price'>{t('UNDER', 'Under')} {filters?.[filter] === 'default' ? options[options?.length - 2] : filters?.[filter]}</p>
        )}
        <ProgressContentWrapper onClick={handleBarClick}>
          <CircleFill style={{ left: '0%', fontSize: '10px' }} />
          <CircleFill style={{ left: `${currentPosition}%`, fontSize: '36px' }} />
          <ProgressBar style={{ width: `${currentPosition}%` }} />
        </ProgressContentWrapper>
        <MaxItemContainer>
          {options.map((option, i) => (
            <MaxItem
              key={option}
              active={filters?.[filter] === option || (option === 'default' && (filters?.[filter] === 'default' || !filters?.[filter]))}
              onClick={() => handleChangeFilters(filter, option)}
            >
              {option === 'default' ? `${parseValue(options[i - 1])}+` : parseValue(option)}
            </MaxItem>
          ))}
        </MaxItemContainer>
      </FilterAccordion>
    </MaxFilterContainer>
  )
}
